<template>
	<v-slider
		:value="value"
		:hide-details="hideDetails"
		:dense="dense"
		:min="min"
		:max="max"
		:ticks="ticks"
		:tick-size="tickSize"
		:step="step"
		:thumb-size="thumbSize"
		:thumb-label="thumbLabel"
		:track-color="trackColor"
		:color="color"
		v-bind="$attrs"
		v-on="unhandled_events"
		@click="on_click"
		@start="on_start"
		@end="on_end"
	/>
</template>

<script>
export default {
	inheritAttrs: false,
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value: {
			type: [String, Number],
			default: 0
		},
		hideDetails: {
			type: [Boolean, String],
			default: false
		},
		dense: {
			type: Boolean,
			default: false
		},
		min: {
			type: [Number, String],
			default: 0
		},
		max: {
			type: [Number, String],
			default: 100
		},
		ticks: {
			type: [Boolean, String],
			default: false
		},
		tickSize: {
			type: [Number, String],
			default: 4
		},
		thumbSize: {
			type: [Number, String],
			default: 32
		},
		thumbLabel: {
			type: [Boolean, String],
			default: false
		},
		trackColor: {
			type: String,
			default: undefined
		},
		step: {
			type: [Number, String],
			default: 1
		},
		color: {
			type: String,
			default: undefined
		}
	},
	computed: {
		unhandled_events() {
			const { click, start, end, ...listeners } = this.$listeners;
			return listeners;
		}
	},
	methods: {
		on_click(event) {
			this.$emit('click', event);
		},
		on_start(event) {
			this.$emit('start', event);
		},
		on_end(event) {
			this.$emit('end', event);
		}
	}
};
</script>